import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/footer/baobah.svg'
import _imports_1 from '../assets/footer/labens-logo.png'
import _imports_2 from '../assets/footer/logo-ehumanas.png'
import _imports_3 from '../assets/footer/logotipo_negativo_ufrn.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "nav-links" }
const _hoisted_4 = { class: "contatos" }
const _hoisted_5 = { class: "labs" }
const _hoisted_6 = { class: "contato" }
const _hoisted_7 = { class: "social-links center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"logos\"><img src=\"" + _imports_0 + "\" class=\"logo-baobah\" alt=\"Logo Baobah\"><div class=\"logos-institucionais\"><img src=\"" + _imports_1 + "\" class=\"logo-labens\" alt=\"Logo Labens\"><img src=\"" + _imports_2 + "\" class=\"logo-ehumanas\" alt=\"Logo E-Humanas\"><img class=\"logo-ufrn\" src=\"" + _imports_3 + "\" alt=\"Logo UFRN\"></div></div>", 1)),
      _createElementVNode("nav", _hoisted_3, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"sitemap\"><h2 class=\"title center\">Mapa do site</h2><div class=\"links\"><ul><li class=\"center\"><a class=\"link\" href=\"/\">Página inicial</a></li><li class=\"center\"><a class=\"link\" href=\"/oas\">Objetos de Aprendizagem</a></li><li class=\"center\"><a class=\"link\" href=\"/sobre\">Sobre</a></li></ul></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "title center" }, "Fale conosco", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "subtitle center" }, "Laboratório E-Humanas", -1)),
              _createElementVNode("ul", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://www.facebook.com/ehumanas.ufrn" }, [
                    _createElementVNode("div", { class: "icon-instance-node fb" })
                  ])
                ], -1)),
                _cache[3] || (_cache[3] = _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://www.instagram.com/ehumanas.ufrn/" }, [
                    _createElementVNode("div", { class: "icon-instance-node ig" })
                  ])
                ], -1)),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "email-link",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.copyEmail && $options.copyEmail(...args)))
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "icon-instance-node email" }, null, -1)
                  ]))
                ])
              ])
            ]),
            _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"contato margin-top\"><h2 class=\"subtitle center\">LABENS</h2><ul class=\"social-links center\"><li><a href=\"https://labens-ufrn.github.io/\"><div class=\"icon-instance-node git\"></div></a></li><li><a href=\"https://www.instagram.com/labens.ufrn/\"><div class=\"icon-instance-node ig\"></div></a></li></ul></div>", 1))
          ])
        ])
      ])
    ])
  ]))
}